import { Button, Modal } from "antd";
import { useWikipedaSearchIfIsNotCurrentUser } from "../../../utils/useWikipedaSearchIfIsNotCurrentUser";
import { useState } from "react";

export const ExplainButton = () => {
  const resultQuery = useWikipedaSearchIfIsNotCurrentUser();

  const [showExplainModal, setShowExplainModal] = useState(false);

  if (!resultQuery.isSuccess) {
    return null;
  }
  return (
    <div
      style={{
        display: "block",
        left: -66,
        top: 244,
        zIndex: 30,
        position: "absolute",
        transform: "rotate(270deg)",
      }}
    >
      <Modal
        destroyOnClose
        visible={showExplainModal}
        title={"Begriffshinweis von Wikipedia"}
        onCancel={() => {
          setShowExplainModal(false);
        }}
        footer={null}
      >
        <p>{resultQuery.data.description}</p>
        <p>{resultQuery.data.extract}</p>
      </Modal>
      <Button
        type={"primary"}
        onClick={() => {
          setShowExplainModal(true);
        }}
      >
        Begriffserklärung 💭
      </Button>
    </div>
  );
};
